import { createBrowserRouter, redirect } from 'react-router-dom'

// Guards
import { ensureAnon, ensureAuthed } from '@/guards'

// Layouts
import ProtectedLayout from '@/layouts/Protected'
import PublicLayout from '@/layouts/Public'

// Pages
import Account from '@/pages/account/Account'
import StepAid from '@/pages/account/steps/Aid'
import StepBackground from '@/pages/account/steps/Background'
import StepsDone from '@/pages/account/steps/Done'
import StepGeneral from '@/pages/account/steps/General'
import StepsIndex from '@/pages/account/steps/Index'
import StepProgram from '@/pages/account/steps/Program'
import Home from '@/pages/public/Home'
import Login from '@/pages/public/Login'
import Parents from '@/pages/public/Parents'
import Counselors from '@/pages/public/Counselors'
import Tuition from '@/pages/public/Tuition'

export const router = createBrowserRouter([
	{
		path: '/',
		element: <PublicLayout />,
		children: [
			{ index: true, element: <Home />, loader: ensureAnon },
			{ path: 'login', element: <Login />, loader: ensureAnon },
			{ path: 'tuition', element: <Tuition /> }, // No loader - accessible to all users
			{ path: 'parents', element: <Parents />, loader: ensureAnon },
			{ path: 'counselors', element: <Counselors />, loader: ensureAnon },
		],
	},
	{
		path: '/account',
		id: 'account-root',
		element: <ProtectedLayout />,
		loader: ensureAuthed,
		children: [
			// /account → redirect by application_process
			{
				index: true,
				loader: async () => {
					const { user } = await ensureAuthed()
					// Non-draft statuses (Submitted, Admitted, Not Accepted) go to done page
					if (user.application_process !== 'Draft') throw redirect('/account/steps/done')
					throw redirect('/account/steps')
				},
				element: <Account />,
			},

			// Steps group (no extra layout — Protected handles sidebar/content)
			{
				path: 'steps',
				loader: async () => {
					const { user } = await ensureAuthed()
					// For non-draft statuses, still allow viewing but lock forms
					return { user }
				},
				children: [
					{ index: true, element: <StepsIndex /> },
					{ path: 'general', element: <StepGeneral />, loader: ensureAuthed },
					{ path: 'background', element: <StepBackground />, loader: ensureAuthed },
					{ path: 'program', element: <StepProgram />, loader: ensureAuthed },
					{ path: 'aid', element: <StepAid />, loader: ensureAuthed },
					{
						path: 'done',
						loader: async () => {
							const { user } = await ensureAuthed()
							// Only allow Done page for non-draft statuses
							if (user.application_process === 'Draft') throw redirect('/account/steps')
							return { user }
						},
						element: <StepsDone />,
					},
				],
			},
		],
	},
	{ path: '*', loader: () => redirect('/') },
])
